jQuery(document).ready(function($) {

	$( '#user_login' ).attr( 'placeholder', 'Enter name' );
	$( '#user_pass' ).attr( 'placeholder', 'Enter password' );

	$('.mobilemenu__trigger').click(function(e){
		e.preventDefault();
		$(this).toggleClass('mobilemenu__trigger--active');
		$('.navigation__menu').toggleClass('navigation__menu--active');

		$('.social__menu--active').removeClass('social__menu--active');
		$('.socialshare__trigger--active').removeClass('socialshare__trigger--active');

		$('.search__trigger--active').removeClass('search__trigger--active');
		$('.search__menu--active').removeClass('search__menu--active');

		$('.member__menu--active').removeClass('member__menu--active');
		$('.member__trigger--active').removeClass('member__trigger--active');
	});

	$('.socialshare__trigger').click(function(e){
		e.preventDefault();
		$(this).toggleClass('socialshare__trigger--active');
		$('.social__menu').toggleClass('social__menu--active');

		$('.navigation__menu--active').removeClass('navigation__menu--active');
		$('.mobilemenu__trigger--active').removeClass('mobilemenu__trigger--active');

		$('.search__trigger--active').removeClass('search__trigger--active');
		$('.search__menu--active').removeClass('search__menu--active');

		$('.member__menu--active').removeClass('member__menu--active');
		$('.member__trigger--active').removeClass('member__trigger--active');
	});

	$('.search__trigger').click(function(e){
		e.preventDefault();
		$(this).toggleClass('search__trigger--active');
		$('.search__menu').toggleClass('search__menu--active');

		$('.social__menu--active').removeClass('social__menu--active');
		$('.socialshare__trigger--active').removeClass('socialshare__trigger--active');

		$('.navigation__menu--active').removeClass('navigation__menu--active');
		$('.mobilemenu__trigger--active').removeClass('mobilemenu__trigger--active');

		$('.member__menu--active').removeClass('member__menu--active');
		$('.member__trigger--active').removeClass('member__trigger--active');
	});

	$('.member__trigger').click(function(e){
		e.preventDefault();
		$(this).toggleClass('member__trigger--active');
		$('.member__menu').toggleClass('member__menu--active');

		$('.social__menu--active').removeClass('social__menu--active');
		$('.socialshare__trigger--active').removeClass('socialshare__trigger--active');

		$('.navigation__menu--active').removeClass('navigation__menu--active');
		$('.mobilemenu__trigger--active').removeClass('mobilemenu__trigger--active');

		$('.search__trigger--active').removeClass('search__trigger--active');
		$('.search__menu--active').removeClass('search__menu--active');
	});

	// This is to prevent body scroll when the modal is open.
	// Uses Bootstrap's modal-open utility class.
	$(document).on('click' , '.trigger__modal', function() {
		$('body').addClass('modal-open');
	});
	$(document).on('click' , '.close__modal', function() {
		$('body').removeClass('modal-open');
	});
	
	//Add animated F to all image rollovers
	$('.image-rollover').prepend('<div class="image-rollover__anif--container"><div class="image-rollover__anif--inner-container"><div class="image-rollover__anif--line image-rollover__anif--line-red1"></div><div class="image-rollover__anif--line image-rollover__anif--line-red2"></div><div class="image-rollover__anif--line image-rollover__anif--line-blue"></div></div></div>'); 

	// Scroll to view
	// Select/Option dropdown
	// $(document).on('click', 'select', function(e) {
	// 	var pos;
	// 	// target element id
	// 	var id = $(this).attr('value');

	// 	// target element
	// 	var $id = $(id);
	// 	if ($id.length === 0) {
	// 		return;
	// 	}

	// 	// prevent standard hash navigation (avoid blinking in IE)
	// 	e.preventDefault();

	// 	// top position relative to the document
	// 	pos = $id.offset().top;
	// 	pos = pos - 80;

	// 	// animated scrolling
	// 	$('body, html').animate({scrollTop: pos});
	// 	$("#fund-jump-select option[value='#select-fund']")[0].selected = true;
	// });

});
